import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/lib/LangContext";

export const FAQ = () => {
  const { t } = useLang();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 lg:py-32 border-b border-white/10"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="mb-12">
          <p className="font-mono-x text-xs tracking-[0.3em] text-brand-500 font-bold">
            {t.faq.overline}
          </p>
          <h2 className="mt-4 font-display font-medium tracking-tighter text-white text-4xl sm:text-5xl">
            {t.faq.title}
          </h2>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {t.faq.items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger className="font-mono-x text-sm uppercase tracking-widest text-white hover:text-brand-500 hover:no-underline py-6 [&[data-state=open]>svg]:text-brand-500">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="font-mono-x text-sm text-slate-300 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
